import React from 'react';
import Chart from 'react-apexcharts';
import { DashboardCard } from './DashboardCard';
import { CancellationReason } from '../../types/checkin';

import { BoxProps } from '@mui/material';

interface CancellationReasonsProps extends BoxProps {
  reasons: CancellationReason[];
}

export const CancellationReasons: React.FC<CancellationReasonsProps> = ({ reasons, sx }) => {
  const series = [
    {
      name: 'Cancelamentos',
      data: reasons.map((r) => r.count),
    },
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 10,
      },
    },
    xaxis: {
      categories: reasons.map((r) => r.reason),
      title: { text: 'Quantidade' },
    },
    dataLabels: {
      enabled: true,
    },
  };

  return (
    <DashboardCard title="Principais Motivos de Cancelamento" sx={sx}>
      <Chart options={options} series={series} type="bar" height={350} />
    </DashboardCard>
  );
};